import "./coupons-popup.css";
import PaymentCouponModal from "../../../paymentCouponModal";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../../../../../../../../App";
import { getAllCoupons } from "../../../../../../../../config/Services";
import Spinner from "../../../../../../../../components/Spinner";
import { useSnackbar } from "../../../../../hooks/SnackbarProvider";

const CouponPopup = ({ type = "GROCERY", couponsModal, setCouponsModal, setShowCoupon }) => {
  const [couponsData, setcouponsData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [couponText, setCouponText] = useState("");
  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  const retailType = localStorage.getItem("retailType");
  const showSnackbar = useSnackbar();
  const overlayRef = useRef(null);

  const { color } = useContext(UserContext);
  const handleCouponModalClose = useCallback(() => setCouponsModal(false), [setCouponsModal]);

  // Close on overlay click
  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) handleCouponModalClose();
  };

  useEffect(() => {
    if (couponsModal) {
      setLoader(true);
      const payload = {
        applicableProductType: [],
        applicableBrand: [],
        applicableLocation: [],
        couponCode: [],
        orgId,
        orgLocId: locId,
        userType: "END_USER",
        channel: "POS",
      };
      getAllCoupons(payload)
        .then((res) => {
          if (res?.data?.status === "error" || res?.data?.data?.es > 0) {
            showSnackbar(res?.data?.message || res?.data?.data?.message || "Error fetching coupons", "error");
            setLoader(false);
            return;
          }
          setcouponsData(res?.data?.data?.coupon);
          setLoader(false);
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          setLoader(false);
        });
    }
  }, [couponsModal]);

  if (!couponsModal) return null;

  return (
    <div
      className="cpd-overlay"
      ref={overlayRef}
      onClick={handleOverlayClick}
    >
      <div className={`cpd-drawer ${couponsModal ? "cpd-drawer--open" : ""}`}>
        {/* Header */}
        <div className="cpd-drawer-header">
          <div className="cpd-drawer-title-wrapper">
            <h1 className="cpd-drawer-title" data-testid="text-action-drawer-title">Coupons</h1>
          </div>
          <div className="cpd-drawer-close-wrapper">
            <button className="cpd-close-btn" onClick={handleCouponModalClose} data-testid="button-action-drawer-close">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x" aria-hidden="true">
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
          </div>
        </div>

        {loader ? (
          <div className="cpd-spinner-wrap">
            <Spinner />
          </div>
        ) : (
          <div className="cpd-body">
            {/* Manual coupon entry — rendered by first PaymentCouponModal */}
            <PaymentCouponModal
              index={0}
              e={couponsData?.[0]}
              setCouponsModal={setCouponsModal}
              couponText={couponText}
              setCouponText={setCouponText}
              couponsData={couponsData}
              type={type}
              setShowCoupon={setShowCoupon}
              drawerMode
            />

            {couponsData?.length > 0 && (
              <>
                <p className="cpd-section-label">AVAILABLE COUPONS</p>
                {couponsData.map((e, i) => (
                  <PaymentCouponModal
                    key={e?.couponId || i}
                    index={i + 1}   /* skip 0 so input row isn't re-rendered */
                    e={e}
                    setCouponsModal={setCouponsModal}
                    couponText={couponText}
                    setCouponText={setCouponText}
                    couponsData={couponsData}
                    type={type}
                    setShowCoupon={setShowCoupon}
                    drawerMode
                  />
                ))}
              </>
            )}

            {couponsData?.length === 0 && !loader && (
              <p className="cpd-no-coupons">No coupons available</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CouponPopup;
